<template>
  <div class="container">
    <div class="render-header">
      <el-image 
        class="banner-image hidden-lg-and-down"
        lazy 
        src="https://cdn.renderg.com/download/www/renderg_dist/images/banner.png" 
        onerror="../../assets/image/loadimg/banner.jpg"
        alt="">
        <div slot="placeholder" class="image-slot">
          <img src="../../assets/image/loadimg/banner.jpg" alt="">
        </div>
      </el-image>
      <el-image 
        class="banner-image hidden-xl-only hidden-sm-only hidden-xs-only"
        lazy 
        :src="require('../../assets/image/price-banner-md.png')" 
        onerror="../../assets/image/loadimg/price-banner-md.jpg"
        alt="">
        <div slot="placeholder" class="image-slot">
          <img src="../../assets/image/loadimg/price-banner-md.jpg" alt="">
        </div>
      </el-image>
      <el-image 
        class="banner-image hidden-xl-only hidden-lg-only hidden-md-only hidden-xs-only"
        lazy 
        :src="require('../../assets/image/price-banner-sm.png')" 
        onerror="../../assets/image/loadimg/price-banner-sm.jpg"
        alt="">
        <div slot="placeholder" class="image-slot">
          <img src="../../assets/image/loadimg/price-banner-sm.jpg" alt="">
        </div>
      </el-image>
      <el-image 
        class="banner-image banner-image hidden-xl-only hidden-lg-only hidden-md-only hidden-sm-only"
        lazy 
        :src="require('../../assets/image/price-banner-xs.png')" 
        onerror="../../assets/image/loadimg/price-banner-xs.jpg"
        alt="">
        <div slot="placeholder" class="image-slot">
          <img src="../../assets/image/loadimg/price-banner-xs.jpg" alt="">
        </div>
      </el-image>
      <div class="header-title">
        <p class="render-h3 mb10">
          即刻体验
        </p>
        <div class="render-h1">
          <span class="active">动画</span>云渲染客户端
        </div>
        <div class="render-subtitle">
          <p class="version-number">版本号：V {{version}}</p>
          <p>更新日期：{{updateTime}}</p>
        </div>
        <div class="info-btn-box hidden-xs-only">
          <a :href="download_aspera">
            <div class="info-btn mb20 flex-align-center flex-center">
              <img src="../../assets/image/render/windows-icon.png" alt="">
              <p>下载Windows版</p>
            </div>
          </a>
          <div class="info-btn flex-align-center flex-center mb20">
            <img src="../../assets/image/render/linux-icon.png" alt="">
            <p>下载Linux版</p>
          </div>
        </div>
        <div class="client-download-desc">
          <p class="mb10">支持Maya、3ds Max、Houdini、Cinema 4d、Clarisse、Katana</p>
          <a :href="download_aspera"><p>Windows7+、CentOS7+</p></a>
        </div>
        <!-- <p class="update-log">更新日志 <span class="el-icon-arrow-up"></span></p> -->
      </div>
      <FastRegister></FastRegister>
    </div>
    <div class="function count-list">
      <div class="function-header">
        <h2 class="mb10">轻便/易用/高效</h2>
        <p class="desc">追求极致渲染体验</p>
      </div>
      <el-row class="">
        <el-col 
          class="flex-center"
          :xs="12" :sm="6" :md="6" :lg="6" :xl="6" 
          v-for="(item, index) in functionList" 
          :key="index">
          <div class="function-box">
            <p>{{ item.title }}</p>
            <div class="function-step">{{item.step}}</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import api from '../../assets/js/api'
import FastRegister from '../register/index'
export default {
  components: {
    FastRegister
  },
  data() {
    return {
      functionList: [
        {
          title: '分析',
          step: 'STEP 1'
        },
        {
          title: '上传',
          step: 'STEP 2'
        },
        {
          title: '渲染',
          step: 'STEP 3'
        },
        {
          title: '下载',
          step: 'STEP 4'
        }
      ],
      download_href: '',
      download_aspera: '',
      version: '',
      updateTime: ''
    }
  },
  created() {
    // this.getType(803)
    this.getType(808)
  },
  methods: {
    getType (value) {
      api.getVersion(value)
        .then((res) => {
          switch (value) {
            case 803:
              this.download_href = res.download_url_cdn
              break;
            case 808:
              this.download_aspera = res.download_url_cdn
              break;
          
            default:
              break;
          }
          this.version = res.version
          var time = res.create_time.split('T')[0]
          var updateTime = time.replace(/-/g, '.')
          this.updateTime = updateTime
        })
    },
  },
}
</script>